import {DatePicker, Space} from 'antd';

const {RangePicker} = DatePicker;
export const DateRangePicker = ({dataSource, setDataSource, copyDataSource}) => {
    const handleChange = (selectDays) => {
        if (selectDays !== null) {
            const filteredData = copyDataSource.filter(data => {
                const dataDate = new Date(data.activity_date);
                // 不能使用 selectDays[0].startOf('day') <= dataDate <= selectDays[1].endOf('day');
                return dataDate >= selectDays[0].startOf('day') && dataDate <= selectDays[1].endOf('day');
            });
            // console.log("filteredData  ", filteredData)
            setDataSource(filteredData);
        } else {
            setDataSource(copyDataSource)
        }
    }

    return (
        <>
            <Space direction="vertical" size={12} style={{marginBottom: 10, float: "right"}}>
                <RangePicker onChange={handleChange}/>
            </Space>
        </>
    )
};